import { useStyles } from './empty-block.style'

export function EmptyBlock ({ children, className = '' }) {
  const classes = useStyles()

  return (
    <div className={`${classes.content} ${className}`}>
      <div className={classes.emptyState}>{children}</div>
    </div>
  )
}
